var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "none",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5L12 8L8 12L12 16L10.5 17.5L5 12L10.5 6.5ZM17.5 6.5L19 8L15 12L19 16L17.5 17.5L12 12L17.5 6.5Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandleft);
export default __webpack_public_path__ + "static/media/expandleft.842b0b681ffc24b4b1195e8fc1739d0a.svg";
export { ForwardRef as ReactComponent };